import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "history-body__summary" }
const _hoisted_2 = { class: "history-body__summary-header" }
const _hoisted_3 = { class: "caption-large--bold color-grey-light" }
const _hoisted_4 = { class: "arrow-box color-grey-light" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "history-body__summary-header_tabs" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "caption-navbar color-grey-light" }
const _hoisted_9 = { class: "history-body__summary-sum" }
const _hoisted_10 = { class: "h1" }
const _hoisted_11 = {
  key: 1,
  class: "progress-empty"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "caption-small--semi-bold" }
const _hoisted_14 = { class: "caption-small--bold" }

import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import HistoryFinancesList from "@/components/history/HistoryFinancesList.vue";
import { useHistoryFinances } from "@/composables/history/useHistoryFinances";
import BaseIcon from "@/components/base/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryFinances',
  setup(__props) {

const store = useStore();
const colorTheme = ref<"moiOperator" | "psb" | "atom">("moiOperator");

const {
  activeCategory,
  categoryTotals,
  choosePeriod,
  filteredOperations,
  formatInternalName,
  isCustomPeriod,
  isOpenedSelect,
  openSelect,
  operationsTabs,
  periodOptions,
  periodText,
  progressBarSegments,
  selectTab,
  toggleCategory,
  totalSum,
  visibleCategoryTabs,
  selectedPeriod,
} = useHistoryFinances();

const tabClasses = (active: boolean) => {
  return [active ? "active" : "", colorTheme.value];
};

onMounted(() => {
  colorTheme.value = store.state.brand.operatorSource;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "history-body__summary-header_period",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(openSelect) && _unref(openSelect)(...args)), ["stop"]))
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(periodText)), 1),
          _createElementVNode("div", _hoisted_4, [
            (_unref(isCustomPeriod))
              ? (_openBlock(), _createBlock(BaseIcon, {
                  key: 0,
                  name: "close",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (selectedPeriod.value = 'year'), ["stop"]))
                }))
              : (_openBlock(), _createBlock(BaseIcon, {
                  key: 1,
                  name: "service-arrow",
                  position: _unref(isOpenedSelect) ? 'top' : 'bottom',
                  onClick: _withModifiers(_unref(openSelect), ["stop"])
                }, null, 8, ["position", "onClick"]))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["period-select", { open: _unref(isOpenedSelect) }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(periodOptions), (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.value,
                class: "period-select__item",
                onClick: _withModifiers(($event: any) => (_unref(choosePeriod)(option.value)), ["stop"])
              }, _toDisplayString(option.label), 9, _hoisted_5))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operationsTabs), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["history-body__summary-header_tabs-item", tabClasses(item.active)]),
              onClick: ($event: any) => (_unref(selectTab)(item.key))
            }, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(item.title), 1)
            ], 10, _hoisted_7))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(totalSum)) + " ₽", 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["history-body__summary-progressBar", colorTheme.value])
      }, [
        (_unref(progressBarSegments).length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(progressBarSegments), (seg) => {
              return (_openBlock(), _createElementBlock("div", {
                key: seg.key,
                class: _normalizeClass(["progress-segment", seg.class]),
                style: _normalizeStyle({ width: seg.percent + '%' })
              }, null, 6))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_11))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["history-body__summary-categories", colorTheme.value])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleCategoryTabs), (cat) => {
          return (_openBlock(), _createElementBlock("div", {
            key: cat.key,
            class: _normalizeClass(["history-body__summary-categories_tab", { active: _unref(activeCategory) === cat.key }]),
            onClick: ($event: any) => (_unref(toggleCategory)(cat.key))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["marker", cat.class])
            }, null, 2),
            _createElementVNode("p", _hoisted_13, [
              _createTextVNode(_toDisplayString(cat.label) + " ", 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(categoryTotals)[cat.key]) + " ₽", 1)
            ])
          ], 10, _hoisted_12))
        }), 128))
      ], 2)
    ]),
    _createVNode(HistoryFinancesList, {
      operations: _unref(filteredOperations),
      "format-internal-name": _unref(formatInternalName)
    }, null, 8, ["operations", "format-internal-name"])
  ], 64))
}
}

})